import React from 'react';
import styled from 'styled-components';
import cssIngka from '@ingka/variables/colours-css';
import useTranslation from '../hooks/useTranslation';

const StyledSvg = styled.svg`
  color: ${cssIngka.colourNeutral7};
`;

const StepIcons = ({ step }: { step: Number | null }) => {
  const { t } = useTranslation();

  switch (step) {
    case 1:
      return <Step1Icon translate={t} />;
    case 2:
      return <Step2Icon translate={t} />;
    case 3:
      return <Step3Icon translate={t} />;
    case 4:
      return <Step4Icon translate={t} />;
  }

  return null;
};

const Step1Icon = ({ translate }: { translate: any }) => {
  const ariaLabelId = 'step-icon-label';
  return (
    <StyledSvg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={ariaLabelId}
    >
      <title id={ariaLabelId}>
        {translate('step-1')} {translate(`spareParts.onboarding.steps.1`)}
      </title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12ZM12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0Z"
        fill="currentColor"
      />
      <path
        d="M11.3947 16.9999V11.2179C11.3947 10.9752 11.3994 10.6579 11.4087 10.2659C11.4274 9.87391 11.4414 9.52857 11.4507 9.22991C11.4041 9.28591 11.3014 9.38857 11.1427 9.53791C10.9934 9.67791 10.8534 9.80391 10.7227 9.91591L9.57473 10.8399L8.55273 9.56591L11.7727 7.00391H13.5087V16.9999H11.3947Z"
        fill="currentColor"
      />
    </StyledSvg>
  );
};

const Step2Icon = ({ translate }: { translate: any }) => {
  const ariaLabelId = 'step-icon-label2';
  return (
    <StyledSvg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={ariaLabelId}
    >
      <title id={ariaLabelId}>
        {translate('step-2')} {translate(`spareParts.onboarding.steps.2`)}
      </title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12ZM12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0Z"
        fill="currentColor"
      />
      <path
        d="M8.58073 17V15.53L11.0867 12.996C11.5907 12.4733 11.9967 12.0393 12.3047 11.694C12.6127 11.3393 12.8367 11.022 12.9767 10.742C13.1167 10.4527 13.1867 10.1447 13.1867 9.81801C13.1867 9.41668 13.0747 9.11801 12.8507 8.92201C12.6361 8.72601 12.3421 8.62801 11.9687 8.62801C11.5861 8.62801 11.2127 8.71668 10.8487 8.89401C10.4847 9.07135 10.1021 9.32335 9.70073 9.65001L8.55273 8.29201C8.83273 8.04001 9.13607 7.80668 9.46273 7.59201C9.7894 7.37735 10.1627 7.20468 10.5827 7.07401C11.0121 6.93401 11.5254 6.86401 12.1227 6.86401C12.7761 6.86401 13.3361 6.98535 13.8027 7.22801C14.2787 7.46135 14.6427 7.78335 14.8947 8.19401C15.1561 8.59535 15.2867 9.05268 15.2867 9.56601C15.2867 10.1167 15.1747 10.6207 14.9507 11.078C14.7361 11.5353 14.4187 11.988 13.9987 12.436C13.5881 12.884 13.0887 13.3787 12.5007 13.92L11.2127 15.124V15.222H15.5667V17H8.58073Z"
        fill="currentColor"
      />
    </StyledSvg>
  );
};

const Step3Icon = ({ translate }: { translate: any }) => {
  const ariaLabelId = 'step-icon-label3';
  return (
    <StyledSvg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={ariaLabelId}
    >
      <title id={ariaLabelId}>
        {translate('step-3')} {translate(`spareParts.onboarding.steps.3`)}
      </title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12ZM12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0Z"
        fill="currentColor"
      />
      <path
        d="M15.1474 9.24401C15.1474 9.93468 14.9374 10.4853 14.5174 10.896C14.1067 11.3067 13.5981 11.5867 12.9914 11.736V11.778C13.7941 11.8713 14.4007 12.114 14.8114 12.506C15.2314 12.898 15.4414 13.4253 15.4414 14.088C15.4414 14.676 15.2967 15.1987 15.0074 15.656C14.7274 16.1133 14.2887 16.4773 13.6914 16.748C13.1034 17.0093 12.3427 17.14 11.4094 17.14C10.3267 17.14 9.36539 16.958 8.52539 16.594V14.802C8.95472 15.0167 9.40272 15.18 9.86939 15.292C10.3454 15.404 10.7841 15.46 11.1854 15.46C11.9414 15.46 12.4687 15.3293 12.7674 15.068C13.0754 14.8067 13.2294 14.438 13.2294 13.962C13.2294 13.682 13.1594 13.4487 13.0194 13.262C12.8794 13.066 12.6321 12.9213 12.2774 12.828C11.9321 12.7253 11.4467 12.674 10.8214 12.674H10.0654V11.05H10.8354C11.4514 11.05 11.9181 10.994 12.2354 10.882C12.5621 10.7607 12.7814 10.602 12.8934 10.406C13.0147 10.2007 13.0754 9.96735 13.0754 9.70601C13.0754 9.35135 12.9634 9.07601 12.7394 8.88001C12.5247 8.67468 12.1607 8.57201 11.6474 8.57201C11.1714 8.57201 10.7561 8.65601 10.4014 8.82401C10.0561 8.98268 9.76206 9.14135 9.51939 9.30001L8.53939 7.84401C8.93139 7.56401 9.38872 7.33068 9.91139 7.14401C10.4434 6.95735 11.0734 6.86401 11.8014 6.86401C12.8281 6.86401 13.6401 7.07401 14.2374 7.49401C14.8441 7.90468 15.1474 8.48801 15.1474 9.24401Z"
        fill="currentColor"
      />
    </StyledSvg>
  );
};

const Step4Icon = ({ translate }: { translate: any }) => {
  const ariaLabelId = 'step-icon-label4';
  return (
    <StyledSvg
      width="24"
      height="24"
      viewBox="0 0 26 26"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      aria-labelledby={ariaLabelId}
    >
      <title id={ariaLabelId}>
        {translate('step-4')} {translate(`spareParts.onboarding.steps.4`)}
      </title>
      <rect
        x="1.20189"
        y="1.33641"
        width="23.0577"
        height="23.0577"
        rx="11.5288"
        stroke="currentColor"
        strokeWidth="2.09615"
      />
      <path
        d="M13.1926 18.2883V16.1167H8.71728V14.576L13.31 7.81175H15.3495V14.4H16.6114V16.1167H15.3495V18.2883H13.1926ZM13.1926 14.4V11.8909C13.1926 11.5485 13.1975 11.2648 13.2072 11.0398C13.2268 10.8148 13.2415 10.6143 13.2513 10.4382H13.1926C13.0263 10.7708 12.816 11.1279 12.5616 11.5094L10.6688 14.4H13.1926Z"
        fill="currentColor"
      />
    </StyledSvg>
  );
};

export default StepIcons;
